module.exports = __webpack_public_path__ + "static/stretch-4ad8514e352ced9c71016f6190227d30.jpg";